// English translations
const translations = {
  common: {
    smartCity: 'LOCA - Traffic Management System',
    dashboard: 'Dashboard',
    map: 'Map',
    analytics: 'Analytics',
    settings: 'Settings',
    profile: 'Profile',
    profileSettings: 'Profile Settings',
    notifications: 'Notifications',
    helpSupport: 'Help & Support',
    systemStatus: 'System Status',
    search: 'Search',
    signOut: 'Sign Out',
    systemRunningNormally: 'System running normally',
    viewAllNotifications: 'View all notifications',
    toggleColorMode: 'Toggle Color Mode',
    administrator: 'Administrator',
    admin: 'Admin',
    user: 'User',
    moderator: 'Moderator',
    manager: 'Manager',
    operator: 'Operator',
    viewer: 'Viewer',
    guest: 'Guest',
    back: 'Back',
    goBack: 'Go Back',
    refresh: 'Refresh',
    last: 'Last',
    export: 'Export',
    type: 'Type',
    sensors: 'Sensors',
    coordinates: 'Coordinates',
    view: 'View',
    details: 'Details',
    active: 'Active',
    inactive: 'Inactive',
    maintenance: 'Maintenance',
    all: 'All',
    error: 'Error',
    errorLoadingData: 'Error loading data',
    name: 'Name',
    address: 'Address',
    status: 'Status',
    latitude: 'Latitude',
    longitude: 'Longitude',
    save: 'Save',
    saving: 'Saving...',
    cancel: 'Cancel',
    success: 'Success',
    required: 'This field is required',
    invalidValue: 'Invalid value',
    invalidRange: 'Value is out of valid range',
    operational: 'Operational',
    notOperational: 'Not Operational',
    timestamp: 'Timestamp',
    deviceId: 'Device ID',
    lastUpdated: 'Last Updated',
    exportData: 'Export Data',
    exportCSV: 'Export CSV',
    exportExcel: 'Export Excel',
    exportPDF: 'Export PDF',
    exportJSON: 'Export JSON',
    exportComplete: 'Export Complete',
    exportSuccessful: 'Export Successful',
    exportFailed: 'Export Failed',
    dataExportedToCSV: 'Data exported to CSV successfully',
    dataExportedToExcel: 'Data exported to Excel successfully',
    dataExportedToPDF: 'Data exported to PDF successfully',
    dataExportedToJSON: 'Data exported to JSON successfully',
    failedToExportData: 'Failed to export data',
    selectColumns: 'Select Columns',
    selectColumnsToExport: 'Select Columns to Export',
    selectAll: 'Select All',
    unselectAll: 'Unselect All',
    pleaseSelectAtLeastOneColumn: 'Please select at least one column',
    exportAsCSV: 'Export as CSV',
    exportAsExcel: 'Export as Excel',
    exportAsPDF: 'Export as PDF',
    csv: 'CSV',
    excel: 'Excel',
    pdf: 'PDF',
    json: 'JSON',
    saveChanges: 'Save Changes',
    updateFailed: 'Update failed',
    errorLoadingLocation: 'Error loading location data',
    backToLocations: 'Back to Locations',
    description: 'Description',
    multiSelect: 'Multi-Select',
    clearSelection: 'Clear Selection',
    confirm: 'Confirm',
    warning: 'Warning',
    loading: 'Loading',
    saved: 'Saved',
    retry: 'Retry',
    reset: 'Reset',
    clear: 'Clear',
    filter: 'Filter',
    sort: 'Sort',
    import: 'Import',
    download: 'Download',
    upload: 'Upload',
    edit: 'Edit',
    create: 'Create',
    update: 'Update',
    add: 'Add',
    remove: 'Remove',
    select: 'Select',
    deselectAll: 'Deselect All',
    none: 'None',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    close: 'Close',
    next: 'Next',
    previous: 'Previous',
    finish: 'Finish',
    submit: 'Submit',
    apply: 'Apply',
    revert: 'Revert',
    restore: 'Restore',

    // Generic states
    searching: 'Searching...',
    creating: 'Creating...',
    generating: 'Generating...',
    processing: 'Processing...',
    updating: 'Updating...',
    clearing: 'Clearing...',
    migrating: 'Migrating...',
    validating: 'Validating...',
    exporting: 'Exporting...',
    delete: 'Delete',
    types: 'Types',
    total: 'Total',
    noSensors: 'No sensors found',
    viewDetails: 'View Details',
    refreshed: 'Refreshed successfully',
    refreshError: 'Failed to refresh',
    showing: 'Showing',
    of: 'of',
    entries: 'entries',
    noResults: 'No results found',
    partialSuccess: 'Partial Success',
  },

  // Landing Page
  landing: {
    tvmSystem: 'TVM System',
    systemOverview: 'System Overview',
    sensorsOnline: 'Sensors Online',
    eventsToday: 'Events Today',
    systemUptime: 'System Uptime',
    fromYesterday: 'from yesterday',
    uptimePeriod: 'Last 30 days avg',
    loadingMap: 'Loading map...',
    myLocation: 'My Location',
    selectLocation: 'Select Location',
    eventType: 'Event Type',
    selectAll: 'Select All',
    clearAll: 'Clear All',
    sensorStatus: 'Sensor Status',
    locationTypes: 'Location Types',
    intersection: 'Intersection',
    highway: 'Highway',
    bridge: 'Bridge',
    tunnel: 'Tunnel',
    parking: 'Parking',
    roundabout: 'Roundabout',
    tollBooth: 'Toll Booth',
    checkpoint: 'Checkpoint',
    allLocations: 'All Locations',
    menu: {
      dashboard: 'Dashboard',
      dashboardDesc: 'View the main dashboard with city traffic overview',
      users: 'Users',
      usersDesc: 'Manage user accounts and permissions',
      sensors: 'Sensors',
      sensorsDesc: 'Monitor and manage all traffic sensors',
      helpSupport: 'Help & Support',
      helpSupportDesc: 'Access help resources and contact support',
      terms: 'Terms of Use',
      termsDesc: 'View the Terms of Use for this application',
    },
  },

  // Layout
  layout: {
    loadingDashboard: 'Loading dashboard...',
  },

  // Clear Incidents specific translations
  'Clear Incidents': 'Clear Incidents',
  'Clearing...': 'Clearing...',
  'Invalid Confirmation': 'Invalid Confirmation',
  'Please type "DELETE ALL INCIDENTS" to confirm': 'Please type "DELETE ALL INCIDENTS" to confirm',
  'Type "DELETE ALL INCIDENTS" to confirm': 'Type "DELETE ALL INCIDENTS" to confirm',
  'This action will permanently delete incidents and cannot be undone. Please proceed with caution.':
    'This action will permanently delete incidents and cannot be undone. Please proceed with caution.',
  'Apply filters to deletion': 'Apply filters to deletion',
  'Incidents to be deleted': 'Incidents to be deleted',
  'All Types': 'All Types',
  'Traffic Violation': 'Traffic Violation',
  Accident: 'Accident',
  Congestion: 'Congestion',
  Roadwork: 'Roadwork',
  Hazard: 'Hazard',
  Closure: 'Closure',
  Weather: 'Weather',
  'Special Event': 'Special Event',
  Other: 'Other',
  'All Statuses': 'All Statuses',
  Pending: 'Pending',
  Active: 'Active',
  Resolved: 'Resolved',
  Closed: 'Closed',
  'From Date': 'From Date',
  'To Date': 'To Date',
  'Include Archived': 'Include Archived',
  // Add System Settings and Configuration section
  settings: {
    dashboard: 'Settings Dashboard',
    system: 'System Settings',
    user: 'User Settings',
    organization: 'Organization Settings',
    security: 'Security Settings',
    notifications: 'Notification Settings',
    integrations: 'Integration Settings',
    maintenance: 'Maintenance Settings',

    // User Management
    'User Management': 'User Management',
    'User Profiles': 'User Profiles',
    'Role Management': 'Role Management',
    'Permission Settings': 'Permission Settings',
    'Access Control': 'Access Control',
    'User Groups': 'User Groups',
    Authentication: 'Authentication',
    'Session Management': 'Session Management',

    // System Configuration
    'System Configuration': 'System Configuration',
    'General Settings': 'General Settings',
    'Performance Settings': 'Performance Settings',
    'Database Settings': 'Database Settings',
    'Cache Settings': 'Cache Settings',
    'Logging Settings': 'Logging Settings',
    'Backup Settings': 'Backup Settings',
    'Import/Export': 'Import/Export',

    // API and Integration Settings
    'API Configuration': 'API Configuration',
    'Rate Limiting': 'Rate Limiting',
    'Webhook Settings': 'Webhook Settings',
    'External APIs': 'External APIs',
    'Data Sync': 'Data Sync',
    'Protocol Settings': 'Protocol Settings',
    'Connection Testing': 'Connection Testing',
    'Integration Status': 'Integration Status',

    // Notification Management
    'Notification Types': 'Notification Types',
    'Email Settings': 'Email Settings',
    'SMS Settings': 'SMS Settings',
    'Push Notifications': 'Push Notifications',
    'Alert Preferences': 'Alert Preferences',
    'Delivery Methods': 'Delivery Methods',
    'Escalation Rules': 'Escalation Rules',
    'Notification Templates': 'Notification Templates',

    // Security Configuration
    'Password Policy': 'Password Policy',
    'Two-Factor Authentication': 'Two-Factor Authentication',
    'IP Restrictions': 'IP Restrictions',
    'SSL/TLS Settings': 'SSL/TLS Settings',
    'Encryption Settings': 'Encryption Settings',
    'Audit Logging': 'Audit Logging',
    'Compliance Settings': 'Compliance Settings',
    'Security Monitoring': 'Security Monitoring',

    // Data Management
    'Data Retention': 'Data Retention',
    'Data Archiving': 'Data Archiving',
    'Data Purging': 'Data Purging',
    'Data Quality': 'Data Quality',
    'Data Sources': 'Data Sources',
    'Data Validation': 'Data Validation',
    'Data Migration': 'Data Migration',
    'Data Backup': 'Data Backup',

    // Application Settings
    'Theme Settings': 'Theme Settings',
    'Language Settings': 'Language Settings',
    'Timezone Settings': 'Timezone Settings',
    'Display Settings': 'Display Settings',
    'Layout Settings': 'Layout Settings',
    'Dashboard Preferences': 'Dashboard Preferences',
    'Widget Configuration': 'Widget Configuration',
    'Chart Settings': 'Chart Settings',

    // System Monitoring
    'Health Monitoring': 'Health Monitoring',
    'Performance Monitoring': 'Performance Monitoring',
    'Resource Usage': 'Resource Usage',
    'System Alerts': 'System Alerts',
    'Error Tracking': 'Error Tracking',
    'Diagnostic Tools': 'Diagnostic Tools',
    'System Status': 'System Status',
    'Maintenance Windows': 'Maintenance Windows',

    // Merged from duplicate settings block
    configurePreferences: 'Configure your dashboard preferences',
    generalSettings: 'General Settings',
    displaySettings: 'Display Settings',
    notificationSettings: 'Notification Settings',
    advancedSettings: 'Advanced Settings',
    language: 'Language',
    languages: {
      english: 'English',
      russian: 'Russian',
      kazakh: 'Kazakh',
    },
    theme: 'Theme',
    light: 'Light',
    dark: 'Dark',
    systemDefault: 'System Default',
    enableNotifications: 'Enable Notifications',
    emailAlerts: 'Email Alerts',
    dataRefreshInterval: 'Data Refresh Interval (minutes)',
    defaultMapView: 'Default Map View',
    trafficView: 'Traffic View',
    satelliteView: 'Satellite View',
    streetsView: 'Streets View',
    darkView: 'Dark View',
    dashboardLayout: 'Dashboard Layout',
    grid: 'Grid',
    list: 'List',
    compact: 'Compact',
    colorScheme: 'Color Scheme',
    blue: 'Blue',
    green: 'Green',
    purple: 'Purple',
    orange: 'Orange',
    red: 'Red',
    dataCardSize: 'Data Card Size',
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    showLegends: 'Show Legends on Charts',
    trafficIncidents: 'Traffic Incidents',
    sensorOfflineAlerts: 'Sensor Offline Alerts',
    congestionAlerts: 'Congestion Alerts',
    systemUpdates: 'System Updates',
    dailyReports: 'Daily Reports',
    advancedUsersNote: 'These settings are for advanced users.',
    apiKey: 'API Key',
    apiKeyNote: 'This key is used for external integrations.',
    developerMode: 'Developer Mode',
    debuggingTools: 'Enables advanced debugging tools',
    dataRetention: 'Data Retention (days)',
    logLevel: 'Log Level',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    debug: 'Debug',
    trace: 'Trace',
    betaFeatures: 'Enable Beta Features',
    resetDefaults: 'Reset to Defaults',
    saveSettings: 'Save Settings',
    saving: 'Saving',
    general: 'General',
    integrationsDescription:
      'Configure third-party integrations, API endpoints, and field mappings for your TVMS.',
  },

  // Add User Interface and Experience section
  ui: {
    navigation: 'Navigation',
    menu: 'Menu',
    toolbar: 'Toolbar',
    sidebar: 'Sidebar',
    footer: 'Footer',
    header: 'Header',
    breadcrumb: 'Breadcrumb',
    pagination: 'Pagination',

    // Form Elements
    'Form Elements': 'Form Elements',
    'Input Fields': 'Input Fields',
    'Select Boxes': 'Select Boxes',
    'Check Boxes': 'Check Boxes',
    'Radio Buttons': 'Radio Buttons',
    'Text Areas': 'Text Areas',
    'File Uploads': 'File Uploads',
    'Date Pickers': 'Date Pickers',
    'Time Pickers': 'Time Pickers',

    // Buttons and Actions
    'Primary Button': 'Primary Button',
    'Secondary Button': 'Secondary Button',
    'Submit Button': 'Submit Button',
    'Cancel Button': 'Cancel Button',
    'Reset Button': 'Reset Button',
    'Edit Button': 'Edit Button',
    'Delete Button': 'Delete Button',
    'Save Button': 'Save Button',
    'Apply Button': 'Apply Button',
    'Close Button': 'Close Button',
    'Back Button': 'Back Button',
    'Next Button': 'Next Button',
    'Previous Button': 'Previous Button',
    'Refresh Button': 'Refresh Button',
    'Search Button': 'Search Button',
    'Clear Button': 'Clear Button',
    'Export Button': 'Export Button',
    'Import Button': 'Import Button',
    'Download Button': 'Download Button',
    'Upload Button': 'Upload Button',

    // Modal and Dialog Elements
    'Modal Dialog': 'Modal Dialog',
    'Confirmation Dialog': 'Confirmation Dialog',
    'Alert Dialog': 'Alert Dialog',
    'Info Dialog': 'Info Dialog',
    'Warning Dialog': 'Warning Dialog',
    'Error Dialog': 'Error Dialog',
    'Success Dialog': 'Success Dialog',
    'Progress Dialog': 'Progress Dialog',

    // Data Display
    'Data Table': 'Data Table',
    'Data Grid': 'Data Grid',
    'List View': 'List View',
    'Card View': 'Card View',
    'Tree View': 'Tree View',
    'Chart View': 'Chart View',
    'Map View': 'Map View',
    'Detail View': 'Detail View',

    // Loading and Status
    'Loading Spinner': 'Loading Spinner',
    'Progress Bar': 'Progress Bar',
    'Status Indicator': 'Status Indicator',
    Badge: 'Badge',
    Label: 'Label',
    Tag: 'Tag',
    Chip: 'Chip',
    Tooltip: 'Tooltip',

    // Layout and Spacing
    'Grid Layout': 'Grid Layout',
    'Flex Layout': 'Flex Layout',
    'Card Layout': 'Card Layout',
    'Panel Layout': 'Panel Layout',
    'Tab Layout': 'Tab Layout',
    'Accordion Layout': 'Accordion Layout',
    'Sidebar Layout': 'Sidebar Layout',
    'Split Layout': 'Split Layout',
  },
  // Add Analytics and Traffic Management enhancements
  analytics: {
    dashboard: 'Analytics Dashboard',
    overview: 'Analytics Overview',
    insights: 'Traffic Insights',
    patterns: 'Traffic Patterns',
    predictions: 'Traffic Predictions',
    realTimeAnalytics: 'Real-time Analytics',
    historicalAnalytics: 'Historical Analytics',
    comparativeAnalysis: 'Comparative Analysis',

    // Advanced Analytics Features
    'Advanced Analytics': 'Advanced Analytics',
    'Machine Learning Insights': 'Machine Learning Insights',
    'Predictive Models': 'Predictive Models',
    'Anomaly Detection': 'Anomaly Detection',
    'Trend Analysis': 'Trend Analysis',
    'Statistical Analysis': 'Statistical Analysis',
    'Performance Metrics': 'Performance Metrics',
    'Data Visualization': 'Data Visualization',

    // Traffic Flow Analysis
    'Traffic Flow Analysis': 'Traffic Flow Analysis',
    'Peak Hours Analysis': 'Peak Hours Analysis',
    'Route Optimization': 'Route Optimization',
    'Congestion Patterns': 'Congestion Patterns',
    'Travel Time Analysis': 'Travel Time Analysis',
    'Speed Analysis': 'Speed Analysis',
    'Volume Analysis': 'Volume Analysis',
    'Density Analysis': 'Density Analysis',

    // Metrics and KPIs
    'Key Performance Indicators': 'Key Performance Indicators',
    'Traffic Volume': 'Traffic Volume',
    'Average Speed': 'Average Speed',
    'Travel Time': 'Travel Time',
    'Congestion Level': 'Congestion Level',
    'Incident Rate': 'Incident Rate',
    'System Efficiency': 'System Efficiency',
    'Environmental Impact': 'Environmental Impact',
    'Safety Score': 'Safety Score',

    // Time-based Analysis
    'Hourly Patterns': 'Hourly Patterns',
    'Daily Patterns': 'Daily Patterns',
    'Weekly Patterns': 'Weekly Patterns',
    'Monthly Trends': 'Monthly Trends',
    'Seasonal Analysis': 'Seasonal Analysis',
    'Year-over-Year Comparison': 'Year-over-Year Comparison',
    'Peak vs Off-Peak': 'Peak vs Off-Peak',
    'Rush Hour Analysis': 'Rush Hour Analysis',

    // Geographic Analysis
    'Geographic Analysis': 'Geographic Analysis',
    'Zone Comparison': 'Zone Comparison',
    'Corridor Analysis': 'Corridor Analysis',
    'Intersection Analysis': 'Intersection Analysis',
    'Regional Patterns': 'Regional Patterns',
    'Hot Spot Analysis': 'Hot Spot Analysis',
    'Network Performance': 'Network Performance',
    'Coverage Analysis': 'Coverage Analysis',

    // Alert and Monitoring
    'Alert Thresholds': 'Alert Thresholds',
    'Performance Monitoring': 'Performance Monitoring',
    'System Health Checks': 'System Health Checks',
    'Data Quality Checks': 'Data Quality Checks',
    'Automated Alerts': 'Automated Alerts',
    'Notification Settings': 'Notification Settings',
    'Alert History': 'Alert History',
    'Escalation Rules': 'Escalation Rules',

    // Export and Sharing
    'Export Analytics': 'Export Analytics',
    'Share Dashboard': 'Share Dashboard',
    'Schedule Reports': 'Schedule Reports',
    'Data Export': 'Data Export',
    'Analytics Report': 'Analytics Report',
    'Insight Summary': 'Insight Summary',
    'Visualization Export': 'Visualization Export',
    'API Access': 'API Access',

    // Configuration and Settings
    'Analytics Configuration': 'Analytics Configuration',
    'Data Sources': 'Data Sources',
    'Calculation Methods': 'Calculation Methods',
    'Aggregation Settings': 'Aggregation Settings',
    'Sampling Rate': 'Sampling Rate',
    'Data Retention': 'Data Retention',
    'Quality Filters': 'Quality Filters',
    'Baseline Settings': 'Baseline Settings',
  },

  // Add Traffic Management enhancements
  trafficManagement: {
    dashboard: 'Traffic Management Dashboard',
    overview: 'Traffic Management Overview',
    control: 'Traffic Control',
    optimization: 'Traffic Optimization',
    incidents: 'Incident Management',

    // Traffic Control Systems
    'Traffic Control Systems': 'Traffic Control Systems',
    'Signal Management': 'Signal Management',
    'Intersection Control': 'Intersection Control',
    'Corridor Management': 'Corridor Management',
    'Adaptive Signals': 'Adaptive Signals',
    'Signal Timing': 'Signal Timing',
    'Phase Management': 'Phase Management',
    'Coordination Plans': 'Coordination Plans',

    // Merged from duplicate analytics block
    title: 'Analytics Dashboard',
    timeRangeFilter: 'Time Range',
    sensorType: 'Sensor Type',
    trafficVolumeOverTime: 'Traffic Volume Over Time',
    vehicleTypeDistribution: 'Vehicle Type Distribution',
    congestionMetrics: 'Congestion Metrics',
    averageDailyTraffic: 'Average Daily Traffic',
    peakHourVolume: 'Peak Hour Volume',
    congestionIndex: 'Congestion Index',
    // Time range options
    timeRange: {
      day: 'Last 24 Hours',
      week: 'Last 7 Days',
      month: 'Last 30 Days',
    },
    metricType: {
      traffic: 'Traffic Volume',
      speed: 'Vehicle Speed',
      incidents: 'Traffic Incidents',
    },
    metrics: {
      totalTraffic: 'Total Traffic Volume',
      avgSpeed: 'Average Speed',
      congestionLevel: 'Congestion Level',
      incidentCount: 'Incident Count',
    },
    trafficByLocation: 'Traffic by Location',
    trafficTrends: 'Traffic Trends',
    trafficPatterns: 'Traffic Patterns',
    speedByLocation: 'Speed by Location',
    speedTrends: 'Speed Trends Over Time',
    speedDistribution: 'Speed Range Distribution',
    speedPatterns: 'Speed Patterns by Time',
    incidentsByLocation: 'Incidents by Location',
    incidentTrends: 'Incident Trends',
    incidentTypes: 'Incident Type Distribution',
    incidentPatterns: 'Incident Patterns',

    // Traffic Flow Management
    'Flow Management': 'Flow Management',
    'Dynamic Routing': 'Dynamic Routing',
    'Load Balancing': 'Load Balancing',
    'Congestion Control': 'Congestion Control',
    'Capacity Management': 'Capacity Management',
    'Queue Management': 'Queue Management',
    'Priority Systems': 'Priority Systems',
    'Emergency Response': 'Emergency Response',

    // Variable Message Signs
    'Variable Message Signs': 'Variable Message Signs',
    'VMS Control': 'VMS Control',
    'Message Management': 'Message Management',
    'Display Status': 'Display Status',
    'Content Library': 'Content Library',
    Scheduling: 'Scheduling',
    'Emergency Messages': 'Emergency Messages',
    'Maintenance Mode': 'Maintenance Mode',

    // Lane Management
    'Lane Management': 'Lane Management',
    'Lane Control Signals': 'Lane Control Signals',
    'Dynamic Lane Assignment': 'Dynamic Lane Assignment',
    'Reversible Lanes': 'Reversible Lanes',
    'HOV Lanes': 'HOV Lanes',
    'Bus Lanes': 'Bus Lanes',
    'Bike Lanes': 'Bike Lanes',
    'Construction Zones': 'Construction Zones',

    // Incident Response
    'Incident Response': 'Incident Response',
    'Emergency Detection': 'Emergency Detection',
    'Response Coordination': 'Response Coordination',
    'Resource Deployment': 'Resource Deployment',
    'Communication Systems': 'Communication Systems',
    'Evacuation Routes': 'Evacuation Routes',
    'Recovery Procedures': 'Recovery Procedures',
    'Post-Incident Analysis': 'Post-Incident Analysis',

    // System Integration
    'System Integration': 'System Integration',
    'SCADA Systems': 'SCADA Systems',
    'Communication Networks': 'Communication Networks',
    'Data Integration': 'Data Integration',
    'Third-party Systems': 'Third-party Systems',
    'API Management': 'API Management',
    'Protocol Support': 'Protocol Support',
    'Legacy System Support': 'Legacy System Support',

    // Performance Optimization
    'Performance Optimization': 'Performance Optimization',
    'Algorithm Tuning': 'Algorithm Tuning',
    'Model Calibration': 'Model Calibration',
    'Parameter Adjustment': 'Parameter Adjustment',
    'Feedback Loops': 'Feedback Loops',
    'Learning Systems': 'Learning Systems',
    'Adaptive Control': 'Adaptive Control',
    'Continuous Improvement': 'Continuous Improvement',

    // Monitoring and Diagnostics
    'System Monitoring': 'System Monitoring',
    'Health Diagnostics': 'Health Diagnostics',
    'Performance Metrics': 'Performance Metrics',
    'Equipment Status': 'Equipment Status',
    'Communication Status': 'Communication Status',
    'Data Quality': 'Data Quality',
    'System Alerts': 'System Alerts',
    'Maintenance Alerts': 'Maintenance Alerts',
  },
  // Add comprehensive Reports System section
  reports: {
    dashboard: 'Reports Dashboard',
    generate: 'Generate Report',
    overview: 'Reports Overview',
    details: 'Report Details',
    search: 'Search reports',
    loading: 'Loading reports...',
    error: 'Error loading reports',
    notFound: 'Report Not Found',
    reportNotFound: 'Report with ID {{id}} was not found',

    // Report Generation
    'Report Generator': 'Report Generator',
    'Select Report Type': 'Select Report Type',
    'Traffic Analysis': 'Traffic Analysis',
    'Incident Summary': 'Incident Summary',
    'Sensor Performance': 'Sensor Performance',
    'System Health': 'System Health',
    'Custom Query': 'Custom Query',
    'Multi-metric Dashboard': 'Multi-metric Dashboard',

    // Report Configuration
    'Report Configuration': 'Report Configuration',
    'Report Settings': 'Report Settings',
    'Data Sources': 'Data Sources',
    'Time Range': 'Time Range',
    'Format Options': 'Format Options',
    'Delivery Options': 'Delivery Options',

    // Time Range Options
    'Last 24 Hours': 'Last 24 Hours',
    'Last 7 Days': 'Last 7 Days',
    'Last 30 Days': 'Last 30 Days',
    'Last 3 Months': 'Last 3 Months',
    'Last 6 Months': 'Last 6 Months',
    'Last Year': 'Last Year',
    'Custom Range': 'Custom Range',
    'Select Date Range': 'Select Date Range',
    'Start Date': 'Start Date',
    'End Date': 'End Date',
    'Invalid date range': 'Invalid date range',
    'End date must be after start date': 'End date must be after start date',

    // Format and Export Options
    'Export Format': 'Export Format',
    'PDF Report': 'PDF Report',
    'Excel Spreadsheet': 'Excel Spreadsheet',
    'CSV Data': 'CSV Data',
    'JSON Data': 'JSON Data',
    'HTML Report': 'HTML Report',
    'Chart Images': 'Chart Images',

    // Delivery Options
    'Auto-schedule': 'Auto-schedule',
    'Email Recipients': 'Email Recipients',
    'Report Frequency': 'Report Frequency',
    'One-time': 'One-time',
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    Quarterly: 'Quarterly',
    'Next Run': 'Next Run',

    // Report Status
    'Report Status': 'Report Status',
    Generating: 'Generating',
    Completed: 'Completed',
    Failed: 'Failed',
    Scheduled: 'Scheduled',
    Cancelled: 'Cancelled',
    'In Queue': 'In Queue',
    Processing: 'Processing',
    'Ready for Download': 'Ready for Download',

    // Actions and Operations
    'Generate Now': 'Generate Now',
    'Schedule Report': 'Schedule Report',
    'Download Report': 'Download Report',
    'View Report': 'View Report',
    'Edit Report': 'Edit Report',
    'Delete Report': 'Delete Report',
    'Copy Report': 'Copy Report',
    'Share Report': 'Share Report',
    'Export Report': 'Export Report',
    'Preview Report': 'Preview Report',
    'Save Template': 'Save Template',
    'Load Template': 'Load Template',

    // Report Templates
    'Report Templates': 'Report Templates',
    'Create Template': 'Create Template',
    'Template Name': 'Template Name',
    'Template Description': 'Template Description',
    'Save as Template': 'Save as Template',
    'Load from Template': 'Load from Template',
    'Delete Template': 'Delete Template',
    'No templates available': 'No templates available',
    'Template saved successfully': 'Template saved successfully',
    'Template loaded successfully': 'Template loaded successfully',

    // Metrics and Data
    'Report Metrics': 'Report Metrics',
    'Include Charts': 'Include Charts',
    'Include Data Tables': 'Include Data Tables',
    'Include Summary': 'Include Summary',
    'Include Recommendations': 'Include Recommendations',
    'Data Aggregation': 'Data Aggregation',
    Hourly: 'Hourly',

    // Validation and Messages
    'Report name is required': 'Report name is required',
    'Please select at least one data source': 'Please select at least one data source',
    'Please select a valid time range': 'Please select a valid time range',
    'Report generated successfully': 'Report generated successfully',
    'Failed to generate report': 'Failed to generate report',
    'Report scheduled successfully': 'Report scheduled successfully',
    'Report deleted successfully': 'Report deleted successfully',
    'Unable to download report': 'Unable to download report',
    'Report is still being generated': 'Report is still being generated',
    'No data available for selected criteria': 'No data available for selected criteria',

    // Statistics
    'Total Reports': 'Total Reports',
    'Generated Today': 'Generated Today',
    'Scheduled Reports': 'Scheduled Reports',
    'Failed Reports': 'Failed Reports',
    'Average Generation Time': 'Average Generation Time',
    'Last Generated': 'Last Generated',
    'Report Size': 'Report Size',
    'Download Count': 'Download Count',

    // Filters and Search
    'Filter by Status': 'Filter by Status',
    'Filter by Type': 'Filter by Type',
    'Filter by Date': 'Filter by Date',
    'Search by Name': 'Search by Name',
    'Clear Filters': 'Clear Filters',
    'No reports found': 'No reports found',
    'No reports match your search criteria': 'No reports match your search criteria',

    // Confirmation Dialogs
    'Are you sure you want to delete this report?': 'Are you sure you want to delete this report?',
    'Are you sure you want to cancel this scheduled report?':
      'Are you sure you want to cancel this scheduled report?',
    'This action cannot be undone': 'This action cannot be undone',
  },

  dashboard: {
    trafficOverview: 'Traffic Overview',
    recentEvents: 'Recent Events',
    sensorStatus: 'Sensor Status',
    systemHealth: 'System Health',
    trafficVolume: 'Traffic Volume',
    incidents: 'Incidents',
    events: 'Events',
    sensors: 'Sensors',
    reports: 'Reports',
    calendar: 'Calendar',
    signalStatus: 'Signal Status',
    averageTravelTime: 'Average Travel Time',
    viewDetails: 'View Details',
    viewAll: 'View All',
    online: 'Online',
    offline: 'Offline',
    uptime: 'Uptime',
    responseTime: 'Response Time',
    dataPoints: 'Data Points',
    lastUpdate: 'Last Update',

    // Added new location page translations
    addNew: 'Add New',
    searchLocations: 'Search locations...',
    filterByType: 'Filter by Type',
    filterByStatus: 'Filter by Status',
    grid: 'Grid',
    list: 'List',
    noLocationsFound: 'No Locations Found',
    tryDifferentSearch: 'Try a different search query or filter',
    locationsDescription: 'Manage and monitor location data',
    locationDetails: 'Location Details',
    locationSensors: 'Location Sensors',
    manageLocation: 'Manage Location',
    addLocation: 'Add Location',
    editLocation: 'Edit Location',
    deleteLocation: 'Delete Location',
    confirmDeleteLocation: 'Are you sure you want to delete this location?',

    // Add location modal translations
    addNewLocation: 'Add New Location',
    locationNamePlaceholder: 'Enter location name',
    locationAddressPlaceholder: 'Enter address',
    locationTypePlaceholder: 'E.g., Intersection, Highway, etc.',
    locationAddedSuccess: 'Location added successfully',
    locationDeletedSuccess: 'Location deleted successfully',
    locationDeleteFailed: 'Failed to delete location',
    deleteLocationsTitle: 'Delete Locations',
    deleteLocationsConfirm: 'Are you sure you want to delete {{count}} location(s)?',
    deleteLocationsWarning:
      'This action cannot be undone. Any sensors connected to these locations will be disconnected.',
    bulkDeleteSuccess: 'Successfully deleted {{count}} locations',
    bulkDeletePartialSuccess:
      'Partially successful: {{success}} locations deleted, {{failed}} failed',
    bulkDeleteFailed: 'Failed to delete locations',
    locationUpdatedSuccess: 'Location updated successfully',
    editLocationDesc: 'Edit location details and coordinates',
    locationDescriptionPlaceholder: 'Enter location description (optional)',
    locationsMap: 'Locations Map',
  },

  map: {
    title: 'Map',
    view3D: '3D View',
    view2D: '2D View',
    fullScreen: 'Full Screen',
    exitFullScreen: 'Exit',
    showSensors: 'Show Sensors',
    showEvents: 'Show Events',
    timeRange: 'Time Range',
    sensorType: 'Sensor Type',
    lastHour: 'Last Hour',
    last24Hours: 'Last 24 Hours',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    allTime: 'All Time',
    filters: 'Filters',
    resetFilters: 'Reset Filters',
    applyFilters: 'Apply Filters',
    eventTypes: 'Event Types',
    sensorTypes: 'Sensor Types',
    sensorStatuses: 'Sensor Statuses',
    trafficViolation: 'Traffic Violation',
    accident: 'Accident',
    maintenance: 'Maintenance',
    numberPlate: 'Number Plate',
    speedViolation: 'Speed Violation',
    other: 'Other',
    camera: 'Camera',
    radar: 'Radar',
    anpr: 'ANPR',
    speedDetector: 'Speed Detector',
    online: 'Online',
    offline: 'Offline',
    error: 'Error',
    saveView: 'Save View',
    legend: 'Legend',
    trafficSensors: 'Traffic Sensors',
    nearbyEvents: 'Nearby Events',
    noEventsInArea: 'No events in this area',
    sensorDetails: 'Sensor Details',
    status: 'Status',
    location: 'Location',
    lastReading: 'Last Reading',
    trafficFlow: 'Traffic Flow',
    averageSpeed: 'Average Speed',
    sensorsShown: 'Sensors: {{count}}',
    eventsShown: 'Events: {{count}}',
  },

  calendar: {
    month: 'Month',
    week: 'Week',
    day: 'Day',
    list: 'List',
    addEvent: 'Add Event',
    eventDetails: 'Event Details',
    title: 'Title',
    description: 'Description',
    location: 'Location',
    startDate: 'Start Date & Time',
    endDate: 'End Date & Time',
    allDay: 'All Day',
    eventType: 'Event Type',
    priority: 'Priority',
    status: 'Status',
    trafficEvent: 'Traffic Event',
    maintenance: 'Maintenance',
    meeting: 'Meeting',
    alert: 'Alert',
    other: 'Other',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    pending: 'Pending',
    inProgress: 'In Progress',
    completed: 'Completed',
    cancelled: 'Cancelled',
    save: 'Save',
    delete: 'Delete',
    cancel: 'Cancel',
    loading: 'Loading calendar...',
    eventCreated: 'Event created',
    eventUpdated: 'Event updated',
    eventDeleted: 'Event deleted',
    assignees: 'Assignees',
    yes: 'Yes',
    no: 'No',
    // FullCalendar specific translations
    currentDay: 'Today',
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    monthNames: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    monthNamesShort: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    buttonText: {
      today: 'Today',
      deleteLocationsWarning: 'Are you sure you want to delete these locations?',
      last30Days: 'Last 30 Days',
      month: 'Month',
      week: 'Week',
      day: 'Day',
      list: 'List',
    },
    allDayText: 'All day',
    moreLinkText: 'more',
    noEventsText: 'No events to display',
    // Add locale property for FullCalendar
    locale: 'en',
  },

  notifications: {
    all: 'All',
    unread: 'Unread',
    read: 'Read',
    archived: 'Archived',
    markAsRead: 'Mark as Read',
    actions: 'Actions',
    markAsUnread: 'Mark as Unread',
    archive: 'Archive',
    delete: 'Delete',
    filterByType: 'Filter by Type',
    allTypes: 'All Types',
    incident: 'Incident',
    system: 'System',
    maintenance: 'Maintenance',
    alert: 'Alert',
    info: 'Info',
    filterBySeverity: 'Filter by Severity',
    allSeverities: 'All Severities',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    critical: 'Critical',
    filterByStatus: 'Filter by Status',
    allStatuses: 'All Statuses',
    selectAll: 'Select All',
    notificationsCount: 'notifications',
    noNotificationsFound: 'No notifications found matching your filters',
    actionRequired: 'Action Required',
    source: 'Source',
    relatedTo: 'Related to',
    noUnread: 'No unread notifications',
    noRead: 'No read notifications',
    noArchived: 'No archived notifications',
    justNow: 'Just now',
    minutesAgo: '{{count}} minutes ago',
    hoursAgo: '{{count}} hours ago',
    yesterday: 'Yesterday',
    daysAgo: '{{count}} days ago',
  },

  // Search translations from translation.json
  search: {
    advancedSearch: 'Advanced Search',
    searchPlaceholder: 'Search events, sensors, or locations...',
    search: 'Search',
    moreFilters: 'More Filters',
    lessFilters: 'Less Filters',
    activeFilters: 'Active Filters',
    clearAll: 'Clear All',
    eventTypes: 'Event Types',
    locations: 'Locations',
    vehicleTypes: 'Vehicle Types',
    car: 'Car',
    bus: 'Bus',
    truck: 'Truck',
    motorcycle: 'Motorcycle',
    bicycle: 'Bicycle',
    speedRange: 'Speed Range',
    customFilter: 'Custom Filter',
    eventType: 'Event Type',
    location: 'Location',
    timestamp: 'Timestamp',
    sensorType: 'Sensor Type',
    speed: 'Speed',
    status: 'Status',
    equals: 'Equals',
    contains: 'Contains',
    greaterThan: 'Greater Than',
    lessThan: 'Less Than',
    range: 'Range',
    addFilter: 'Add Filter',
    results: 'Results',
    selectEventType: 'Select Event Type',
    selectLocation: 'Select Location',
    selectSensorType: 'Select Sensor Type',
    enterSpeed: 'Enter Speed in km/h',
    enterValue: 'Enter Value',
  },

  spotlight: {
    placeholder: 'Search pages, features, settings...',
    quickResults: 'QUICK RESULTS',
    noResults: 'No quick results found for "{{query}}"',
    tryAdvanced: 'Try the advanced search for more comprehensive results',
    navigate: 'Navigate',
    select: 'Select',
    close: 'Close',
    advancedSearch: 'Advanced Search',
    items: {
      trafficEvents: 'View and manage traffic events',
      seatbeltViolations: 'Monitor seatbelt violation events',
      trafficAnalytics: 'View traffic analytics dashboard',
      sensors: 'Manage traffic sensors',
      users: 'Manage users and permissions',
      system: 'Configure system settings',
      vehicleLogs: 'View vehicle traffic logs',
      notifications: 'Manage system notifications',
      workers: 'Monitor background workers',
      search: 'Open the full search page',
    },
  },
  integration: {
    title: 'Integrations',
    tester: 'Integration Tester',
    testerDescription: 'Test your integration endpoints',
    url: 'URL',
    requestHeaders: 'Request Headers',
    bodyNotAllowed: 'Body not allowed for GET requests',
    testing: 'Testing...',
    test: 'Test',
    responseBody: 'Response Body',
    responseHeaders: 'Response Headers',
    apiKeys: 'API Keys',
    createApiKey: 'Create API Key',
    deleteApiKey: 'Delete API Key',
    regenerateApiKey: 'Regenerate API Key',
    apiKeyName: 'API Key Name',
    apiKeyValue: 'API Key Value',
    apiKeyCreated: 'API Key Created',
    apiKeyDeleted: 'API Key Deleted',
    apiKeyRegenerated: 'API Key Regenerated',
    copyApiKey: 'Copy API Key',
    confirmDeleteApiKey: 'Are you sure you want to delete this API key?',
    noApiKeys: 'No API keys found',

    endpoints: 'Endpoints',
    createEndpoint: 'Create Endpoint',
    deleteEndpoint: 'Delete Endpoint',
    endpointName: 'Endpoint Name',
    endpointUrl: 'Endpoint URL',
    endpointMethod: 'Method',
    endpointCreated: 'Endpoint Created',
    endpointDeleted: 'Endpoint Deleted',
    noEndpoints: 'No endpoints found',

    fieldMappings: 'Field Mappings',
    createMapping: 'Create Mapping',
    deleteMapping: 'Delete Mapping',
    mappingName: 'Mapping Name',
    sourceField: 'Source Field',
    targetField: 'Target Field',
    mappingCreated: 'Mapping Created',
    mappingDeleted: 'Mapping Deleted',
    noMappings: 'No field mappings found',

    testIntegrations: 'Test Integrations',
    savedTests: 'Saved Tests',
    testConfiguration: 'Test Configuration',
    testName: 'Test Name',
    testDescription: 'Test Description',
    method: 'Method',
    endpoint: 'Endpoint',
    headers: 'Headers',
    headerKey: 'Header Key',
    headerValue: 'Header Value',
    requestBody: 'Request Body',
    jsonBody: 'JSON Body',
    execute: 'Execute',
    response: 'Response',
    testSaved: 'Test saved successfully',
    testDeleted: 'Test deleted successfully',
    noSavedTests: 'No saved tests found',
    requiredFields: 'Name and endpoint are required',
    endpointRequired: 'Endpoint is required',
  },

  // Add sidebar translations
  sidebar: {
    app: {
      name: 'Pixuate',
    },
    main: 'Main',
    overview: 'Overview',
    dashboard: 'Dashboard',
    map: 'Map',
    calendar: 'Calendar',
    analytics: 'Analytics',
    search: 'Search',
    notifications: 'Notifications',
    location: 'Location',
    incidents: 'Incidents',
    archive: 'Archive',
    monitoring: 'Monitoring',
    sensorManagement: 'Sensor Management',
    sensors: 'Sensors',
    sensorHealth: 'Sensor Health',
    events: 'Events',
    trafficManagement: 'Traffic Management',
    trafficLogs: 'Sensor Logs',
    speedEvents: 'Speed Events',
    trafficEvents: 'Traffic Events',
    trafficViolations: 'Traffic Violations',
    seatbeltViolations: 'Seatbelt Violations',
    seatbeltEvents: 'Seatbelt Events',
    trafficAnalytics: 'Traffic Analytics',
    violationEvents: 'Violation Events',
    violationAnalytics: 'Violation Analytics',
    reports: 'Reports',
    administration: 'Administration',
    users: 'Users',
    userRoles: 'User Roles',
    system: 'System',
    systemHealth: 'System Health',
    integrations: 'Integrations',
    translations: 'Translations',
    storage: 'Storage',
    backups: 'Backups',
    license: 'License',
    licenseManagement: 'License Management',
    help: 'Help',
    queueManager: 'Queue Manager',
    workers: 'Workers',
    workerLogs: 'Worker Logs',
    locations: 'Locations',
    locationManagement: 'Location Management',
  },

  // Update header translations
  header: {
    expandSidebar: 'Expand Sidebar',
    collapseSidebar: 'Collapse Sidebar',
    language: 'Change Language',
    selectLanguage: 'Select Language',
    recentNotifications: 'Recent Notifications',
    notificationTitle: 'System Alert',
    notificationDesc: 'A new system alert requires your attention.',
    help: 'Help',
    toggleTheme: 'Toggle Theme',
  },

  // Add new sensor health translations
  sensorHealth: {
    dashboard: 'Sensor Health Dashboard',
    overview: 'Sensor Health Overview',
    details: 'Sensor Details',
    loading: 'Loading sensor...',
    error: 'Error loading sensor',
    notFound: 'Sensor Not Found',
    sensorNotFound: 'Sensor with ID {{id}} was not found',
    editSensor: 'Edit Sensor',
    exportData: 'Export Data',

    // Missing sensor management keys
    'Add New Sensor': 'Add New Sensor',
    'Sensor Configuration': 'Sensor Configuration',
    'Basic Information': 'Basic Information',
    'Sensor Attributes': 'Sensor Attributes',
    'Location Details': 'Location Details',
    'Network Settings': 'Network Settings',

    // Form Fields
    'Sensor Name': 'Sensor Name',
    'Enter sensor name': 'Enter sensor name',
    'Device ID': 'Device ID',
    'Enter device ID': 'Enter device ID',

    metrics: {
      uptime: 'Uptime',
      signalStrength: 'Signal Strength',
      batteryLevel: 'Battery Level',
      responseTime: 'Response Time',
      dataRate: 'Data Rate',
      temperature: 'Temperature',
      humidity: 'Humidity',
      errorRate: 'Error Rate',
      packetLoss: 'Packet Loss',
      connectionStatus: 'Connection Status',
      operationalStatus: 'Operational Status',
      firmwareVersion: 'Firmware Version',
      hardwareVersion: 'Hardware Version',
      lastCalibration: 'Last Calibration',
      selfTestStatus: 'Self-Test Status',
      lastUpdated: 'Last Updated',
    },
    alerts: {
      title: 'Alerts',
      noAlerts: 'No alerts',
      lowBattery: 'Low Battery',
      signalLoss: 'Signal Loss',
      highTemperature: 'High Temperature',
      maintenance: 'Maintenance Required',
      severity: {
        low: 'Low',
        medium: 'Medium',
        high: 'High',
        critical: 'Critical',
      },
      status: {
        active: 'Active',
        resolved: 'Resolved',
        acknowledged: 'Acknowledged',
        ignored: 'Ignored',
      },
    },
    sensorId: 'Sensor ID',
    lastUpdated: 'Last Updated',
    batteryLevel: 'Battery Level',
    signalStrength: 'Signal Strength',
    status: {
      online: 'Online',
      offline: 'Offline',
      warning: 'Warning',
      error: 'Error',
      maintenance: 'Maintenance',
      all: 'All Sensors',
      connected: 'Connected',
      disconnected: 'Disconnected',
      intermittent: 'Intermittent',
      active: 'Active',
      idle: 'Idle',
    },
    diagnostics: {
      title: 'Diagnostics',
      selfTest: 'Self Test',
      passed: 'Passed',
      failed: 'Failed',
      voltage: 'Voltage',
      memory: 'Memory Usage',
      cpu: 'CPU Usage',
      errorCodes: 'Error Codes',
    },
    performance: {
      title: 'Performance',
      excellent: 'Excellent',
      good: 'Good',
      fair: 'Fair',
      poor: 'Poor',
      packetLoss: 'Packet Loss',
      latency: 'Latency',
      jitter: 'Jitter',
      throughput: 'Throughput',
    },
    filter: {
      searchPlaceholder: 'Search sensors...',
      filterByStatus: 'Filter by Status',
      applyFilters: 'Apply Filters',
      resetFilters: 'Reset Filters',
      sortBy: 'Sort By',
      showAdvancedFilters: 'Show Advanced Filters',
      hideAdvancedFilters: 'Hide Advanced Filters',
      clearAllFilters: 'Clear all filters',
      searchByNameOrId: 'Search sensors by name or ID',
    },
    actions: {
      viewDetails: 'View Details',
      refreshData: 'Refresh Data',
      exportData: 'Export Data',
      createAlert: 'Create Alert',
      scheduleMaintenence: 'Schedule Maintenance',
      resetSensor: 'Reset Sensor',
      selectSensor: 'Select a Sensor to View Details',
      chooseSensor: 'Choose a sensor',
      recalibrate: 'Recalibrate',
      restart: 'Restart',
      requiresAttention: 'Requires attention',
    },
    stats: {
      totalSensors: 'Total Sensors',
      healthySensors: 'Healthy Sensors',
      warningSensors: 'Warning Sensors',
      criticalSensors: 'Critical Sensors',
      maintenanceSensors: 'Maintenance Sensors',
      averageUptime: 'Average Uptime',
      averageBattery: 'Average Battery Level',
      alertsLast24h: 'Alerts (24h)',
    },
    charts: {
      batteryLevelTrend: 'Battery Level Trend',
      signalStrengthTrend: 'Signal Strength Trend',
      alertsOverTime: 'Alerts Over Time',
      statusDistribution: 'Status Distribution',
      responseTimeTrend: 'Response Time Trend',
      uptimePercentage: 'Uptime Percentage',
    },
    tabs: {
      allSensors: 'All Sensors',
      healthy: 'Healthy',
      warning: 'Warning',
      critical: 'Critical',
      maintenance: 'Maintenance',
    },
    healthLog: {
      title: 'Health Log',
      noData: 'No Health Log Data Available',
      noLogsReceived: 'No health log entries have been received from this sensor',
      deviceStatus: 'Device Status',
      radarStatus: 'Radar Status',
      cameraStatus: 'Camera Status',
      gpsStatus: 'GPS Status',
      ledStatus: 'LED Status',
      latestStatus: 'Latest Status Summary',
      systemHealth: 'System Health',
      allSystemsOperational: 'All Systems Operational',
      systemIssuesDetected: 'System Issues Detected',
      lastStatusUpdate: 'Last Status Update',
    },
  },

  // License management translations
  license: {
    // General
    License: 'License',
    'License Management': 'License Management',
    'License Information': 'License Information',
    'License Status': 'License Status',
    'License Key': 'License Key',
    'License Expired': 'License Expired',
    'License Valid': 'License Valid',
    'License Invalid': 'License Invalid',
    'System Access Blocked': 'System Access Blocked',
    'Action Required': 'Action Required',
    'Grace Period': 'Grace Period',
    'Grace Period Remaining': 'Grace Period Remaining',
    'Grace Period Expired': 'Grace Period Expired',
    Days: 'Days',
    'Expiration Date': 'Expiration Date',
    'Days Since Expiration': 'Days Since Expiration',
    Expired: 'Expired',
    Active: 'Active',
    Inactive: 'Inactive',
    'Refresh License': 'Refresh License',
    'Check License Status': 'Check License Status',
    'Refreshing...': 'Refreshing...',
    'Checking License...': 'Checking License...',
    'Log Out': 'Log Out',
    'Logging out...': 'Logging out...',
    Close: 'Close',

    // Status messages
    'Your license has expired and requires immediate attention':
      'Your license has expired and requires immediate attention',
    'Expired on': 'Expired on',
    'Days since expiration': 'Days since expiration',
    'You have {{days}} day(s) remaining in the grace period. Please renew your license immediately.':
      'You have {{days}} day(s) remaining in the grace period. Please renew your license immediately.',
    'The grace period has expired. System access is now restricted.':
      'The grace period has expired. System access is now restricted.',
    'Next automatic check in': 'Next automatic check in',
    'Required Actions': 'Required Actions',
    'Contact your system administrator to renew the license':
      'Contact your system administrator to renew the license',
    'Log out and log back in after license renewal':
      'Log out and log back in after license renewal',
    'Or refresh the license status if already renewed':
      'Or refresh the license status if already renewed',

    // Blocked error page
    'License Grace Period Expired': 'License Grace Period Expired',
    'The system license has been expired beyond the allowed grace period. All user access is now blocked.':
      'The system license has been expired beyond the allowed grace period. All user access is now blocked.',
    'Contact your system administrator or license provider immediately':
      'Contact your system administrator or license provider immediately',
    'Renew or update your system license': 'Renew or update your system license',
    'Restart the license verification service after renewal':
      'Restart the license verification service after renewal',
    'Try logging in again after license renewal': 'Try logging in again after license renewal',
    'Need Help?': 'Need Help?',
    Email: 'Email',
    Phone: 'Phone',
    'Please provide your license key when contacting support':
      'Please provide your license key when contacting support',
    'This page will automatically refresh once the license is renewed and validated':
      'This page will automatically refresh once the license is renewed and validated',
    'TVMS - Traffic Management System': 'TVMS - Traffic Management System',

    // Connection failure translations
    'License Server Unavailable': 'License Server Unavailable',
    'Connection Required': 'Connection Required',
    'Unable to connect to license verification server':
      'Unable to connect to license verification server',
    'License status cannot be verified at this time':
      'License status cannot be verified at this time',
    'Connection Details': 'Connection Details',
    'Server URL': 'Server URL',
    'Connection Status': 'Connection Status',
    Failed: 'Failed',
    'Auto-retry in': 'Auto-retry in',
    'Security Notice': 'Security Notice',
    'For security reasons, system access requires license verification. Please ensure the license service is running and accessible.':
      'For security reasons, system access requires license verification. Please ensure the license service is running and accessible.',
    'Troubleshooting Steps': 'Troubleshooting Steps',
    'Check if the license service is running on port 45678':
      'Check if the license service is running on port 45678',
    'Verify network connectivity to the license server':
      'Verify network connectivity to the license server',
    'Contact your system administrator if the issue persists':
      'Contact your system administrator if the issue persists',
    'Try logging out and back in after the service is restored':
      'Try logging out and back in after the service is restored',
    'Need immediate assistance?': 'Need immediate assistance?',
    'Contact support at support@tvms.local or restart the license verification service.':
      'Contact support at support@tvms.local or restart the license verification service.',
    'Checking...': 'Checking...',
    'Retry Connection': 'Retry Connection',

    // View and manage translations
    'View and manage your system license.': 'View and manage your system license.',
    'View and manage your system license, check expiration status, and update license keys':
      'View and manage your system license, check expiration status, and update license keys',
  },

  sensorManagement: {
    'Unique identifier for this sensor': 'Unique identifier for this sensor',
    'Enter sensor description': 'Enter sensor description',
    'Sensor Type': 'Sensor Type',
    'Initial Status': 'Initial Status',
    'Select Location': 'Select Location',
    'Loading locations...': 'Loading locations...',
    'Select a location': 'Select a location',
    'No locations available': 'No locations available',
    'Create a new location': 'Create a new location',
    'IP Address': 'IP Address',

    // Sensor Types
    Camera: 'Camera',
    Radar: 'Radar',
    ANPR: 'ANPR',
    'Speed Detector': 'Speed Detector',

    // Camera Attributes
    Resolution: 'Resolution',
    'Select Resolution': 'Select Resolution',
    'Frame Rate (FPS)': 'Frame Rate (FPS)',
    'Night Vision': 'Night Vision',
    'Storage Retention (Days)': 'Storage Retention (Days)',

    // Radar Attributes
    'Range (meters)': 'Range (meters)',
    'Accuracy (meters)': 'Accuracy (meters)',
    'Detection Zones': 'Detection Zones',

    // ANPR Attributes
    'Recognition Accuracy (%)': 'Recognition Accuracy (%)',
    'Capture Rate (vehicles/minute)': 'Capture Rate (vehicles/minute)',
    'Database Integration': 'Database Integration',

    // Speed Detector Attributes
    'Max Speed (km/h)': 'Max Speed (km/h)',
    'Min Speed (km/h)': 'Min Speed (km/h)',
    'Lanes Covered': 'Lanes Covered',

    // Status and Actions
    'Total Sensors': 'Total Sensors',
    'Last Active': 'Last Active',
    'Events Rate': 'Events Rate',
    'events/min': 'events/min',
    'Add Sensor': 'Add Sensor',
    Grid: 'Grid',
    Table: 'Table',
    'Search sensors': 'Search sensors',
    'Delete Sensor': 'Delete Sensor',
    'Cannot delete sensors with data': 'Cannot delete sensors with data',
    'No sensors found matching your criteria': 'No sensors found matching your criteria',

    edit: {
      success: 'Sensor updated successfully',
      error: 'Failed to update sensor',
    },

    // Validation Messages
    'Sensor name is required': 'Sensor name is required',
    'Device ID is required': 'Device ID is required',
    'Invalid IP address format': 'Invalid IP address format',
    'Frame rate must be positive': 'Frame rate must be positive',
    'Storage retention must be positive': 'Storage retention must be positive',
    'Range must be positive': 'Range must be positive',
    'Validation Error': 'Validation Error',
    'Please correct the errors in the form': 'Please correct the errors in the form',
    'Sensor created successfully': 'Sensor created successfully',
    'Failed to create sensor. Please try again.': 'Failed to create sensor. Please try again.',
    'Creating...': 'Creating...',
    'Create Sensor': 'Create Sensor',
    'Are you sure you want to delete this sensor? This action cannot be undone.':
      'Are you sure you want to delete this sensor? This action cannot be undone.',
    'Sensor deletion would be implemented here. SensorID: ':
      'Sensor deletion would be implemented here. SensorID: ',
  },

  // Incident Management - Complete Missing Section
  incidents: {
    // Core Navigation and Headers
    Incidents: 'Incidents',
    'Incident Details': 'Incident Details',
    'Create Incident': 'Create Incident',
    'Edit Incident': 'Edit Incident',
    'Delete Incident': 'Delete Incident',
    Back: 'Back',
    Actions: 'Actions',

    // Status Management
    'Mark as Processed': 'Mark as Processed',
    'Mark as Resolved': 'Mark as Resolved',
    Archive: 'Archive',
    Unarchive: 'Unarchive',
    Processed: 'Processed',
    Yes: 'Yes',
    No: 'No',
    Active: 'Active',
    Resolved: 'Resolved',

    // Incident Information Fields
    ID: 'ID',
    Type: 'Type',
    Description: 'Description',
    Location: 'Location',
    Time: 'Time',
    'Sensor ID': 'Sensor ID',
    'Sensor Name': 'Sensor Name',
    Created: 'Created',
    Updated: 'Updated',
    Archived: 'Archived',
    Duration: 'Duration',
    'Generated on': 'Generated on',

    // Traffic Metrics
    'Traffic Metrics': 'Traffic Metrics',
    'Traffic Volume': 'Traffic Volume',
    'vehicles/hour': 'vehicles/hour',
    'Average Speed': 'Average Speed',
    mph: 'mph',
    'Congestion Level': 'Congestion Level',
    High: 'High',
    Moderate: 'Moderate',

    // Related and Timeline
    'Related Incidents': 'Related Incidents',
    'Incident Timeline': 'Incident Timeline',
    'Incident Information': 'Incident Information',
    'Incident ID': 'Incident ID',
    Status: 'Status',
    'Incident Report': 'Incident Report',

    // Search and Filtering
    'Search incidents': 'Search incidents',
    'All Incidents': 'All Incidents',
    Pending: 'Pending',
    From: 'From',
    To: 'To',
    Reset: 'Reset',
    'Incident Type': 'Incident Type',

    // Export and Actions
    'Export as PDF': 'Export as PDF',
    'View Details': 'View Details',

    // Status Messages and Errors
    'No incidents found': 'No incidents found',
    'Error loading incidents': 'Error loading incidents',
    'Searching for "{{term}}"...': 'Searching for "{{term}}"...',
    'Showing {{count}} results for "{{term}}"': 'Showing {{count}} results for "{{term}}"',
    'No incidents found for "{{term}}". Try adjusting your search or filters.':
      'No incidents found for "{{term}}". Try adjusting your search or filters.',
    'No incidents found matching your criteria': 'No incidents found matching your criteria',
    'Incident not found': 'Incident not found',
    'Unknown location': 'Unknown location',
  },

  // Global Error Messages
  errors: {
    searchNameRequired: 'Search name is required',
    emptySearch: 'Search query cannot be empty',
    unknownError: 'An unknown error occurred',
    searchSaveFailed: 'Failed to save search',
    searchDeleteFailed: 'Failed to delete search',
    historyClearFailed: 'Failed to clear history',
    historyItemRemoveFailed: 'Failed to remove history item',
    settingsUpdateFailed: 'Failed to update settings',
    eventRestoreFailed: 'Failed to restore event',
    archiveSettingsUpdateFailed: 'Failed to update archive settings',
    archiveProcessFailed: 'Failed to start archive process',
  },

  // Global Success Messages
  success: {
    searchSaved: 'Search saved successfully',
    searchDeleted: 'Search deleted successfully',
    historyCleared: 'Search history cleared',
    historyItemRemoved: 'History item removed',
    settingsUpdated: 'Settings updated successfully',
    eventRestored: 'Event restored successfully',
    archiveSettingsUpdated: 'Archive settings updated successfully',
    archiveProcessStarted: 'Archive process started',
  },

  // Empty States - Actionable empty state messages with illustrations
  emptyStates: {
    // Sensors
    noSensors: {
      title: 'No Sensors Found',
      description: 'Get started by adding your first sensor to monitor traffic and collect data.',
      primaryAction: 'Add Sensor',
      secondaryAction: 'Learn More',
    },
    noSensorsFiltered: {
      title: 'No Matching Sensors',
      description:
        'No sensors match your current filter criteria. Try adjusting your filters or search terms.',
      primaryAction: 'Clear Filters',
    },

    // Locations
    noLocations: {
      title: 'No Locations Found',
      description: 'Add locations to organize your sensors and monitor traffic at specific areas.',
      primaryAction: 'Add Location',
      secondaryAction: 'Import Locations',
    },
    noLocationsFiltered: {
      title: 'No Matching Locations',
      description:
        'No locations match your search. Try a different search term or browse all locations.',
      primaryAction: 'Clear Search',
    },

    // Events
    noEvents: {
      title: 'No Events Found',
      description:
        'Traffic events will appear here once sensors start detecting activity. Verify that your sensors are online and properly configured.',
      primaryAction: 'Check Sensors',
      secondaryAction: 'Refresh',
    },
    noEventsFiltered: {
      title: 'No Matching Events',
      description:
        'No events match your current filters. Try adjusting the date range, changing filter criteria, or verifying sensor connectivity.',
      descriptionWithQuery:
        'No events match "{{query}}". Try different search terms, adjust the date range, or check your filter criteria.',
      descriptionWithEventId: 'No event found with ID "{{query}}". Verify the event ID is correct.',
      primaryAction: 'Clear Filters',
      secondaryAction: 'Refresh',
    },

    // Violations
    noViolations: {
      title: 'No Violations Found',
      description:
        'No violations match your current filters. Try adjusting the date range or violation type.',
      primaryAction: 'Adjust Filters',
      secondaryAction: 'Refresh',
    },

    // Seatbelt Violations
    noSeatbeltViolations: {
      title: 'No Seatbelt Violations',
      description:
        'Seatbelt violations will appear here once sensors start detecting them. Verify that your sensors are online and properly configured to detect seatbelt violations.',
      primaryAction: 'Check Sensors',
      secondaryAction: 'Refresh',
    },
    noSeatbeltViolationsFiltered: {
      title: 'No Matching Violations',
      description:
        'No seatbelt violations match your current filters. Try adjusting the date range, changing filter criteria, or expanding your search parameters.',
      descriptionWithQuery:
        'No seatbelt violations match "{{query}}". Try different search terms, adjust the date range, or check your filter criteria.',
      descriptionWithEventId:
        'No seatbelt violation found with ID "{{query}}". Verify the event ID is correct.',
      primaryAction: 'Clear Filters',
      secondaryAction: 'Refresh',
    },

    // Reports
    noReports: {
      title: 'No Reports Yet',
      description:
        'Create custom reports to analyze traffic patterns, sensor data, and violations over time.',
      primaryAction: 'Create Report',
      secondaryAction: 'View Templates',
    },

    // Notifications
    noNotifications: {
      title: 'No Notifications',
      description:
        "You're all caught up! New notifications will appear here when there's activity.",
      primaryAction: 'Notification Settings',
    },
    allNotificationsRead: {
      title: 'All Caught Up!',
      description: 'You have no unread notifications.',
      primaryAction: 'View All',
    },

    // Search Results
    noSearchResults: {
      title: 'No Results Found',
      description: 'No results found. Try different keywords or broaden your search.',
      descriptionWithQuery:
        'No results found for "{{query}}". Try different keywords or check for typos.',
      primaryAction: 'Clear Search',
      secondaryAction: 'Adjust Filters',
      tipsTitle: 'Search Tips',
      tips: {
        checkSpelling: 'Check your spelling and try again',
        useKeywords: 'Use more general keywords',
        removeFilters: 'Remove some filters to broaden your search',
        tryDifferentTerms: 'Try different search terms',
      },
    },

    // Archive
    noArchive: {
      title: 'No Archived Events',
      description:
        'Events are automatically archived based on your retention policy. Archived events are preserved for compliance and historical analysis while keeping your active database optimized.',
      primaryAction: 'Configure Retention Policy',
      secondaryAction: 'Learn More',
    },
    noArchiveFiltered: {
      title: 'No Matching Archived Events',
      description:
        'No archived events match your current filters. Try adjusting the date range, event type, or severity level.',
      descriptionWithQuery:
        'No archived events match "{{query}}". Try different search terms or adjust your filter criteria.',
      primaryAction: 'Clear Filters',
      secondaryAction: 'Refresh',
    },

    // Generic No Data
    noData: {
      title: 'No Data Available',
      description: 'There is no data to display at this time. Check back later or try refreshing.',
      primaryAction: 'Refresh',
    },
  },
};

export default translations;
